"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormCapacitySelect", {
    enumerable: true,
    get: function() {
        return FormCapacitySelect;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _useCapacityIconBackground = require("./useCapacityIconBackground");
const _FormInput = require("../FormInput/FormInput");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormCapacitySelect = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children: _, ...props } = param;
    return /*#__PURE__*/ _react.default.createElement(_FormInput.FormInput, {
        ...props,
        type: "number",
        placeholder: "Capacity",
        min: "1",
        max: "999",
        ref: ref,
        dropdownIcon: _useCapacityIconBackground.useCapacityIconBackground
    });
});
FormCapacitySelect.displayName = "FormCapacityInput";

//# sourceMappingURL=FormCapacitySelect.js.map